import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { Actions, ActivitiesWrapper, StyledRemove, StyledSettings } from './Activities.styles';

interface ActivitiesProps {
  title?: string;
  onClick: () => void;
  onRemove?: () => void;
  type?: string;
}

export const Activities: React.FC<ActivitiesProps> = ({ title, onClick, onRemove, type }) => {
  const { t } = useTranslation();

  return (
    <ActivitiesWrapper>
      <Typography fontWeight={500}>{title ?? t('user.overview.agendaOverview')}</Typography>
      <Actions>
        {type === 'AgendaView' && <StyledSettings onClick={onClick} />}
        <StyledRemove onClick={onRemove} />
      </Actions>
    </ActivitiesWrapper>
  );
};
